import * as React from "react";
import styled from "@mui/material/styles/styled";
import { Menu, MenuItem } from "@mui/material";
import { featureTo2Lines } from "fe-common/logic";
import Button from "@mui/material/Button";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import { MobileView } from "../../../util/aKaunGeneralUtil";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";

//region [[ Styles ]]

const ArrowIcon = styled(SubdirectoryArrowRightIcon)(({ theme }) => ({
  color: KahunColorMap.DefaultLight,
  marginTop: "-3px",
  marginRight: "4px",
  [theme.breakpoints.down(MobileView)]: {
    fontSize: "18px",
    color: "white",

    marginTop: "0px",
    marginRight: "4px",
  },
}));

const OpenMenuIcon = styled(ArrowDropDownIcon)(({ theme }) => ({
  color: KahunColorMap.DefaultLight,
  marginLeft: "2px",

  marginTop: "1px",

  [theme.breakpoints.down(MobileView)]: {
    color: "white",
  },
}));

const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
  paddingTop: "0px",
  paddingBottom: "0px",
}));

const SubTypeButton = styled(Button)(({ theme }) => ({
  padding: "8px",
  color: KahunColorMap.DefaultLight,
  borderRadius: "0",
  fontSize: "14px",
  display: "flex",
  justifyContent: "center",
  height: "20px",
  marginTop: "10px",

  "& .MuiButton-label": {
    maxWidth: "300px",
    wordWrap: "normal",
    whiteSpace: "nowrap",
    overflow: "hidden",
    display: "inline-block",
    textOverflow: "ellipsis",
  },

  [theme.breakpoints.down(MobileView)]: {
    marginLeft: "-4px",
    marginTop: "0px",
    fontSize: "14px",
    height: "unset",
    fontWeight: 500,
    color: "white",
  },
  textTransform: "unset",
}));

const SubTypeLabel = styled("div")(({ theme }) => ({
  fontWeight: 500,
  fontSize: "14px",
}));

const ButtonContent = styled("div")(({ theme }) => ({
  display: "flex",
}));

const FormLabel = styled(FormControlLabel)(({ theme }) => ({
  marginRight: "0px",
}));

const MenuStyled = styled(Menu)(({ theme }) => ({
  borderRadius: "30px",
}));

const SubTypesMenuView = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginLeft: "-3px",
  [theme.breakpoints.down(MobileView)]: {
    marginLeft: "20px",
  },
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface SubTypesMenuProps {
  subTypes: any;
  selected: any;
  onSelect: (cr, subType) => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const SubTypesMenu = ({ ...props }: SubTypesMenuProps) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const selectedSubTypeFeature = props.selected
    ? props.selected.disease[0]
    : null;
  const [selectedSubType] = selectedSubTypeFeature
    ? featureTo2Lines(selectedSubTypeFeature)
    : ["Subtypes"];

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const handleChange = (event, subtype, cr) => {
    event.stopPropagation();
    setAnchorEl(null);
    props.onSelect(subtype, cr);
  };

  return (
    <SubTypesMenuView>
      <SubTypeButton
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <ButtonContent>
          <ArrowIcon />
          {selectedSubType}
          <OpenMenuIcon />
        </ButtonContent>
      </SubTypeButton>

      <MenuStyled
        PaperProps={{
          style: {
            borderRadius: "8px",
          },
        }}
        id="simple-menu"
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {props.subTypes.map((cr) => {
          const subTypeFeature = cr.disease[0];
          const [subType] = featureTo2Lines(subTypeFeature);
          return (
            <MenuItemStyled
              key={cr.id}
              onClick={(event) => {
                handleChange(event, cr, subType);
              }}
            >
              <FormLabel
                value={cr}
                control={<Radio />}
                label=""
                onChange={(event) => {
                  handleChange(event, cr, subType);
                }}
                checked={props.selected === cr}
              />
              <SubTypeLabel>{subType}</SubTypeLabel>
            </MenuItemStyled>
          );
        })}

        <MenuItemStyled
          onClick={(event) => {
            handleChange(event, null, "");
          }}
        >
          <FormLabel
            value={""}
            control={<Radio />}
            label=""
            onChange={(event) => {
              handleChange(event, null, "");
            }}
            checked={props.selected === null}
          />
          <SubTypeLabel>{"None"}</SubTypeLabel>
        </MenuItemStyled>
      </MenuStyled>
    </SubTypesMenuView>
  );
};
